module.exports = __webpack_public_path__ + "assets/a8d7404f4c5348a9a23bf446f4ae412d.json";